import { getJwtToken } from "../config";
import { ContextService } from "globals/helpers";

type DefaultRequestHeaderType = {
  "Content-Type": string;
  Accept: string;
};

type RequestHeaderWithJwtType = DefaultRequestHeaderType & {
  Authorization: string;
};

class RequestHeaderService {
  /**
   * Returns the default headers.
   */
  getDefaultHeaders(): { headers: DefaultRequestHeaderType } {
    return {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  }

  /**
   * Returns the default headers having a JWT.
   */
  getHeadersWithJwt(): { headers: RequestHeaderWithJwtType } {
    return {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${getJwtToken()}`,
      },
    };
  }

  getHeaders() {
    return ContextService.isAnonymous()
      ? this.getDefaultHeaders()
      : this.getHeadersWithJwt();
  }
}

export default new RequestHeaderService();
